const conversationIcon =
  "https://appflzt.oss-cn-shanghai.aliyuncs.com/static-h5/AI_H5/theme/blue/conversation_icon_active.png";

const submitBtnIcon =
  "https://appflzt.oss-cn-shanghai.aliyuncs.com/static-h5/AI_H5/theme/blue/submitBtn_icon_big.png";

const stopRecordBtn_big =
  "https://appflzt.oss-cn-shanghai.aliyuncs.com/static-h5/AI_H5/theme/blue/stopRecordBtn_big.png";

// 特殊编码抬头
const specialCodeHead = "$@$@";
const specialCodeArr = [
  "000",
  "001",
  "002",
  "003",
  "004",
  "005",
  "006",
  "007",
  "008",
  "009",
  "010",
  "011",
  "012",
  "013",
  "014",
];

const deepSeekHead = "<think>";
const deepSeekFooter = "</think>";

// 图片特殊抬头
const imgContentHead = "![";

// 该配置只记录要跳转的原始域名地址 具体跳转路径放到业务逻辑代码中维护
const appCodeMap = {
  // 道行龙城 柳州app
  dxlc_lz_app: {
    "000": {},
    // 实时公交
    "001": {
      realTimeBusUrl_test: "https://lzgj.test.brightcns.cn/onlineBus/",
      realTimeBusUrl_prod: "https://h5-lzgj.brightcns.com/onlineBus/",
    },
    // 智能出行maas
    "002": {
      maasUrl_test: "https://lzgj.test.brightcns.cn/MaaS-v2/",
      maasUrl_prod: "https://h5-lzgj.brightcns.com/MaaS-v2/",
    },
    // 打车
    "003": {
      takeTaxiUrl_test: "https://lzgj.test.brightcns.cn/take-taxi/",
      takeTaxiUrl_prod: "https://h5-lzgj.brightcns.com/take-taxi/",
    },
    // 汽车票
    "004": {
      coachBusUrl_test: "https://lzgj.test.brightcns.cn/glx/",
      coachBusUrl_prod: "https://h5-lzgj.brightcns.com/glx/",
    },
    // 火车票
    "005": {
      trainUrl_test:
        "https://m.ly.com/trainnin1/touch/#/index?refid=2000020811",
      trainUrl_prod:
        "https://m.ly.com/trainnin1/touch/#/index?refid=2000020811",
    },
    // 机票
    "006": {
      airplaneUrl_test:
        "https://m.ly.com/ft/touch/index?platcode=518&refId=2000020811",
      airplaneUrl_prod:
        "https://m.ly.com/ft/touch/index?platcode=518&refId=2000020811",
    },
    // 权益中心
    "012": {
      equityCenterUrl_test: "https://lzgj.test.brightcns.cn/benefits/",
      equityCenterUrl_prod: "https://h5-lzgj.brightcns.com/benefits/",
    },
    // 积分商城
    "013": {
      pointMallUrl_test: "https://lzgj.test.brightcns.cn/benefits/",
      pointMallUrl_prod: "https://h5-lzgj.brightcns.com/benefits/",
    },
    // 付费会员
    "014": {
      vipUrl_test: "https://lzgj.test.brightcns.cn/benefits/",
      vipUrl_prod: "https://h5-lzgj.brightcns.com/benefits/",
    },
  },
  // 道行龙城 微信小程序
  dxlc_lz_wechat: {
    "000": {},
    // 实时公交
    "001": {
      realTimeBusUrl_test: "https://lzgj.test.brightcns.cn/onlineBus/",
      realTimeBusUrl_prod: "https://h5-lzgj.brightcns.com/onlineBus/",
    },
    // 汽车票
    "004": {
      coachBusUrl_test: "https://lzgj.test.brightcns.cn/glx/",
      coachBusUrl_prod: "https://h5-lzgj.brightcns.com/glx/",
    },
    // 火车票
    "005": {
      trainUrl_test:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
      trainUrl_prod:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
    },
    // 机票
    "006": {
      airplaneUrl_test:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
      airplaneUrl_prod:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
    },
    // 权益中心
    "012": {
      equityCenterUrl_test: "https://lzgj.test.brightcns.cn/benefits/",
      equityCenterUrl_prod: "https://h5-lzgj.brightcns.com/benefits/",
    },
    // 积分商城
    "013": {
      pointMallUrl_test: "https://lzgj.test.brightcns.cn/benefits/",
      pointMallUrl_prod: "https://h5-lzgj.brightcns.com/benefits/",
    },
  },
  // 畅行南通 app
  cxnt_xh_app: {
    "000": {},
    // 实时公交
    "001": {
      realTimeBusUrl_test: "https://h5-ntgj.test.brightcns.cn/onlineBus/",
      realTimeBusUrl_prod: "https://h5-maas.speedits.com/onlineBus/",
    },
    // 汽车票
    "004": {
      coachBusUrl_test: "https://h5-ntgj.test.brightcns.cn/coach/",
      coachBusUrl_prod: "https://h5-maas.speedits.com/coach/",
    },
    // 火车票
    "005": {
      trainUrl_test:
        "https://m.ly.com/trainnin1/touch/#/index?refid=2000118572",
      trainUrl_prod:
        "https://m.ly.com/trainnin1/touch/#/index?refid=2000118572",
    },
    // 机票
    "006": {
      airplaneUrl_test:
        "https://m.ly.com/ft/touch/index?platcode=518&refId=2000118572",
      airplaneUrl_prod:
        "https://m.ly.com/ft/touch/index?platcode=518&refId=2000118572",
    },
    // 停车
    "007": {
      parkCarUrl_test: "https://h5-ntgj.test.brightcns.cn/parking/",
      parkCarUrl_prod: "https://h5-maas.speedits.com/parking/",
    },
    // 地铁路线
    "008": {
      subwayLineUrl_test: "https://h5-ntgj.test.brightcns.cn/metro/#/IndexPage",
      subwayLineUrl_prod: "https://h5-maas.speedits.com/metro/#/IndexPage",
    },
    // 列车位置
    "009": {
      subwayLocationUrl_test: "https://h5-ntgj.test.brightcns.cn/metro/",
      subwayLocationUrl_prod: "https://h5-maas.speedits.com/metro/",
    },
    // 地铁票价
    "010": {
      subwayPriceUrl_test: "https://h5-ntgj.test.brightcns.cn/metro/",
      subwayPriceUrl_prod: "https://h5-maas.speedits.com/metro/",
    },
    // 地铁首末班
    "011": {
      subwayTimeTableUrl_test: "https://h5-ntgj.test.brightcns.cn/metro/",
      subwayTimeTableUrl_prod: "https://h5-maas.speedits.com/metro/",
    },
    // 权益中心
    "012": {
      equityCenterUrl_test: "https://h5-ntgj.test.brightcns.cn/benefits/",
      equityCenterUrl_prod: "https://h5-maas.speedits.com/benefits/",
    },
    // 积分商城
    "013": {
      pointMallUrl_test: "https://h5-ntgj.test.brightcns.cn/benefits/",
      pointMallUrl_prod: "https://h5-maas.speedits.com/benefits/",
    },
  },
  // 畅行南通 微信小程序
  cxnt_xh_wechat: {
    "000": {},
    // 实时公交
    "001": {
      realTimeBusUrl_test: "https://h5-ntgj.test.brightcns.cn/onlineBus/",
      realTimeBusUrl_prod: "https://h5-maas.speedits.com/onlineBus/",
    },
    // 汽车票
    "004": {
      coachBusUrl_test: "https://h5-ntgj.test.brightcns.cn/coach/",
      coachBusUrl_prod: "https://h5-maas.speedits.com/coach/",
    },
    // 火车票
    "005": {
      trainUrl_test:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000118572&tab=1",
      trainUrl_prod:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000118572&tab=1",
    },
    // 机票
    "006": {
      airplaneUrl_test:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000118572&tab=1",
      airplaneUrl_prod:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000118572&tab=1",
    },
    // 停车
    "007": {
      parkCarUrl_test: "https://h5-ntgj.test.brightcns.cn/parking/",
      parkCarUrl_prod: "https://h5-maas.speedits.com/parking/",
    },
    // 地铁路线
    "008": {
      subwayLineUrl_test: "https://h5-ntgj.test.brightcns.cn/metro/#/IndexPage",
      subwayLineUrl_prod: "https://h5-maas.speedits.com/metro/#/IndexPage",
    },
    // 列车位置
    "009": {
      subwayLocationUrl_test: "https://h5-ntgj.test.brightcns.cn/metro/",
      subwayLocationUrl_prod: "https://h5-maas.speedits.com/metro/",
    },
    // 地铁票价
    "010": {
      subwayPriceUrl_test: "https://h5-ntgj.test.brightcns.cn/metro/",
      subwayPriceUrl_prod: "https://h5-maas.speedits.com/metro/",
    },
    // 地铁首末班
    "011": {
      subwayTimeTableUrl_test: "https://h5-ntgj.test.brightcns.cn/metro/",
      subwayTimeTableUrl_prod: "https://h5-maas.speedits.com/metro/",
    },
    // 权益中心
    "012": {
      equityCenterUrl_test: "https://h5-ntgj.test.brightcns.cn/benefits/",
      equityCenterUrl_prod: "https://h5-maas.speedits.com/benefits/",
    },
    // 积分商城
    "013": {
      pointMallUrl_test: "https://h5-ntgj.test.brightcns.cn/benefits/",
      pointMallUrl_prod: "https://h5-maas.speedits.com/benefits/",
    },
  },
  // 测试用
  dxlc_test: {
    "000": {},
    // 实时公交
    "001": {
      realTimeBusUrl_test: "https://lzgj.test.brightcns.cn/onlineBus/",
      realTimeBusUrl_prod: "https://h5-lzgj.brightcns.com/onlineBus/",
    },
    // 智能出行maas
    "002": {
      maasUrl_test: "https://lzgj.test.brightcns.cn/MaaS-v2/",
      maasUrl_prod: "https://h5-lzgj.brightcns.com/MaaS-v2/",
    },
    // 打车
    "003": {
      takeTaxiUrl_test: "https://lzgj.test.brightcns.cn/take-taxi/",
      takeTaxiUrl_prod: "https://h5-lzgj.brightcns.com/take-taxi/",
    },
    // 汽车票
    "004": {
      coachBusUrl_test: "https://lzgj.test.brightcns.cn/glx/",
      coachBusUrl_prod: "https://lzgj.brightcns.com/glx/",
    },
    // 火车票
    "005": {
      trainUrl_test:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
      trainUrl_prod:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
    },
    // 机票
    "006": {
      airplaneUrl_test:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
      airplaneUrl_prod:
        "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
    },
    // 权益中心
    "012": {
      equityCenterUrl_test: "https://lzgj.test.brightcns.cn/benefits/",
      equityCenterUrl_prod: "https://h5-lzgj.brightcns.com/benefits/",
    },
    // 积分商城
    "013": {
      pointMallUrl_test: "https://lzgj.test.brightcns.cn/benefits/",
      pointMallUrl_prod: "https://h5-lzgj.brightcns.com/benefits/",
    },
    // 付费会员
    "014": {
      vipUrl_test: "https://lzgj.test.brightcns.cn/benefits/",
      vipUrl_prod: "https://h5-lzgj.brightcns.com/benefits/",
    },
  },
};

export {
  conversationIcon,
  submitBtnIcon,
  stopRecordBtn_big,
  appCodeMap,
  specialCodeHead,
  specialCodeArr,
  deepSeekHead,
  deepSeekFooter,
  imgContentHead,
};
